/*
*
* File JS per la Basic Page
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroImage from 'imComponents/hero-image/hero-image';

import blockText from 'components/block-text/block-text';

import image from 'imComponents/image/image';

import blockTextImg from 'components/block-text-img/block-text-img';

import blockTextOneImg from 'components/block-text-one-img/block-text-one-img';

import blockBannerSimple from 'components/block-banner-simple/block-banner-simple';

import blockGalleryOffScreen from 'components/gallery-off-screen/gallery-off-screen';

import blockTwoImg from 'components/block-two-img/block-two-img';

import blockAccessories from 'components/block-accessories';

import blockDispositions from '../../components/block-dispositions';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './basic-page.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

blockGalleryOffScreen();

//--------------------------------------------------------------------//